module.exports = __webpack_public_path__ + "img/d189f40.jpg";